module.exports = __webpack_public_path__ + "static/media/share.b9df66ed.svg";